import type { JSX } from 'react';
import { ConfirmDialog } from '@/components/ui/confirm-dialog.js';
import { IgnoreReasonDialog } from './ignore-reason-dialog.js';
import type { OrderActionController } from './use-order-action-controller.js';

/** Dialogues partagés par `order-row-actions.tsx` et `order-header.tsx` (voir `use-order-action-controller.ts`). */
export function OrderActionDialogs({ controller }: { controller: OrderActionController }): JSX.Element {
  return (
    <>
      <ConfirmDialog
        open={controller.confirmAction !== null}
        onOpenChange={(open) => {
          if (!open) controller.closeConfirm();
        }}
        title={controller.confirmTitle}
        description={controller.confirmDescription}
        confirmLabel="Renvoyer"
        isConfirming={controller.confirmPending}
        onConfirm={controller.runConfirmed}
      />

      <IgnoreReasonDialog
        open={controller.ignoreOpen}
        onOpenChange={(open) => {
          if (!open) controller.closeIgnore();
        }}
        description={`La commande ${controller.order.name} sera marquée ignorée.`}
        isConfirming={controller.ignorePending}
        onConfirm={controller.runIgnore}
      />
    </>
  );
}
